import { registrationApi } from '../registrationApi';
import { RegistrationType } from '../types/registrationTypes';
import type { RegistrationCreateRequest } from '../requests/registrationCreateRequest';
import type { RegistrationUpdateRequest } from '../requests/registrationUpdateRequest';
import type { RegistrationLookupRequest } from '../requests/registrationLookupRequest';

const registrationEndpointsInjected = registrationApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get registration by ID
    // GET /registration?id=<id>
    getRegistration: builder.query<RegistrationType, { id: string }>({
      query: ({ id }) => `/registration?id=${encodeURIComponent(id)}`,
      providesTags: (result, error, { id }) => [{ type: 'Registration', id }],
    }),

    // Create registration
    // POST /registration
    createRegistration: builder.mutation<RegistrationType, RegistrationCreateRequest>({
      query: (registrationCreateRequest) => ({
        url: '/registration',
        method: 'POST',
        body: registrationCreateRequest,
      }),
      invalidatesTags: ['Registrations'],
    }),

    // Update registration
    // POST /registrationUpdate
    updateRegistration: builder.mutation<RegistrationType, RegistrationUpdateRequest>({
      query: (registrationUpdateRequest) => ({
        url: '/registrationUpdate',
        method: 'POST',
        body: registrationUpdateRequest,
      }),
      invalidatesTags: ['Registrations', 'Registration'],
    }),

    // Lookup registrations by search term
    // GET /registrationLookup?company=<company>&center=<center>&searchTerm=<searchTerm>
    lookupRegistrations: builder.query<RegistrationType[], RegistrationLookupRequest>({
      query: ({ company, center, searchTerm }) =>
        `/registrationLookup?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&searchTerm=${encodeURIComponent(searchTerm)}`,
      providesTags: ['Registrations'],
    }),
  }),
  overrideExisting: false,
});

// Export enhanced API for slice extraReducers
export const registrationEndpoints = registrationEndpointsInjected;

export const {
  useGetRegistrationQuery,
  useCreateRegistrationMutation,
  useUpdateRegistrationMutation,
  useLookupRegistrationsQuery,
} = registrationEndpointsInjected;
